module.exports = __webpack_public_path__ + "06_long_gold.7a2effea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_long_gold.png
// module id = HMhY
// module chunks = 0